// components/ErrorPopup.tsx
import React, { useState } from 'react';
import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { useErrorPopup } from "@app/data/logger/useErrorPopup";

const ErrorPopup: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [details, setDetails] = useState<Record<string, any> | undefined>(undefined);

  useErrorPopup((msg, det) => {
    setMessage(msg);
    setDetails(det);
    setOpen(true);
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // 🔥 вот тут центр сверху
    >
      <Alert
        onClose={handleClose}
        severity="error"
        variant="filled"
        sx={{
          width: '100%',
          minWidth: '300px',
          maxWidth: '600px',
          mx: 'auto',
        }}
      >
        <AlertTitle>Ошибка</AlertTitle>
        {message}
        {details && (
          <pre style={{ fontSize: '0.75rem', marginTop: '8px' }}>
            {JSON.stringify(details, null, 2)}
          </pre>
        )}
      </Alert>
    </Snackbar>
  );
};

export default ErrorPopup;
